<template>
  <div class="row">
    <div class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-6">
              <b-form-group label="Name:">
                <b-form-input
                  id="form-input-name"
                  name="form-input-name"
                  v-model="itemForm.name"
                  v-validate="{ required: false, min: 1 }"
                  :state="validateState('form-input-name')"
                  data-vv-as="Name"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-name-feedback"
                >
                  {{ veeErrors.first('form-input-name') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-12 col-md-6">
              <b-form-group label="Subdomain:">
                <b-form-input
                  id="form-input-subDomain"
                  name="form-input-subDomain"
                  v-model="itemForm.subDomain"
                  v-validate="{ required: false, min: 1 }"
                  :state="validateState('form-input-subDomain')"
                  data-vv-as="Subdomain"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-subDomain-feedback"
                >
                  {{ veeErrors.first('form-input-subDomain') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-12 col-md-6">
              <b-form-group label="Or use Full Domain:">
                <b-form-input
                  id="form-input-mainDomain"
                  name="form-input-mainDomain"
                  v-model="itemForm.mainDomain"
                  v-validate="{ required: false, min: 1 }"
                  :state="validateState('form-input-mainDomain')"
                  data-vv-as="mainDomain"
                />
                <b-form-invalid-feedback
                  id="form-input-mainDomain-feedback"
                >
                  {{ veeErrors.first('form-input-mainDomain') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-6">
              <b-form-group label="Status:">
                <b-v-select
                  id="form-input-active"
                  name="form-input-active"
                  v-model="itemForm.active"
                  v-validate="{ required: false }"
                  :state="validateState('form-input-active')"
                  :searchable="true"
                  :options="statusList"
                />
                <b-form-invalid-feedback id="form-input-active-feedback">
                  {{ veeErrors.first('form-input-active') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-12 col-md-6">
              <b-form-group label="Webhook Notify Url:" description="A webhook URL that will get notifications for when a new reply gets posted on a ticket.">
                <b-form-input
                  id="form-input-webhookNotifyUrl"
                  name="form-input-webhookNotifyUrl"
                  v-model="itemForm.webhookNotifyUrl"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-webhookNotifyUrl')"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-webhookNotifyUrl-feedback"
                >
                  {{ veeErrors.first('form-input-webhookNotifyUrl') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-12 col-md-6">
              <b-form-group label="Linear Client Id:">
                <b-form-input
                  id="form-input-linearClientId"
                  name="form-input-linearClientId"
                  v-model="itemForm.linearClientId"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-linearClientId')"
                  data-vv-as="Linear Client Id"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-linearClientId-feedback"
                >
                  {{ veeErrors.first('form-input-linearClientId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-12 col-md-6">
              <b-form-group label="Linear Team Id:">
                <b-form-input
                  id="form-input-linearTeamId"
                  name="form-input-linearTeamId"
                  v-model="itemForm.linearTeamId"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-linearTeamId')"
                  data-vv-as="Linear Team Id"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-linearTeamId-feedback"
                >
                  {{ veeErrors.first('form-input-linearTeamId') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-12 col-md-6">
              <b-form-group label="Linear Client Secret:">
                <b-form-input
                  id="form-input-linearClientSecret"
                  name="form-input-linearClientSecret"
                  v-model="itemForm.linearClientSecret"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-linearClientSecret')"
                  data-vv-as="Linear Client Secret"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-linearClientSecret-feedback"
                >
                  {{ veeErrors.first('form-input-linearClientSecret') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

            <div class="col-12 col-md-6">
              <b-form-group label="Linear Auth Token:">
                <b-form-input
                  id="form-input-linearAuthToken"
                  name="form-input-linearAuthToken"
                  v-model="itemForm.linearAuthToken"
                  v-validate="{ required: true }"
                  :state="validateState('form-input-linearAuthToken')"
                  data-vv-as="Linear Auth Token"
                  required
                />
                <b-form-invalid-feedback
                  id="form-input-linearAuthToken-feedback"
                >
                  {{ veeErrors.first('form-input-linearAuthToken') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>

          </div>
        </div>
      </b-card>
    </div>
    <aside class="col-12 col-sm-3">
      <b-card header="Actions">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          type="submit"
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          :disabled="savingItem"
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Admin.Projects.Index' }"
        >
          <span>Cancel</span>
        </router-link>
      </b-card>
    </aside>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapStoreGetSet } from '@/helpers/utils/storeHelpers.js';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [crudMixinGen('projects'), myCommonDataMixin],
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    custForm: {
      name: '',
      value: '',
    },
    custTableFields: [
      { key: 'name', label: 'Name', sortable: true },
      { key: 'value', label: 'Value', sortable: true },
      { key: 'id', label: 'Action', sortable: false }
    ],
    heading: 'Shipping Code Mapping',
    fulfillmentServicesList: [
      {
        value: 'ShipStation',
        text: 'ShipStation'
      },
      {
        value: 'IRMS',
        text: 'IRMS'
      },
      {
        value: 'Landmark',
        text: 'Landmark'
      },
      {
        value: 'Crane',
        text: 'Crane'
      },
      {
        value: 'TPL',
        text: 'Extensiv'
      }
    ],
    statusList: [
      {
        value: true,
        text: 'Active'
      },
      {
        value: false,
        text: 'In-Active'
      }
    ]
  }),

  computed: {
  },

  mounted() {
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id);
    } else {
      this.ResetForm();
    }
  },

  methods: {
    SaveForm() {
      this.$store.dispatch('fetchMyTPLData');
      this.savingItem = true;
      this.SaveItem()
        .then(resp => {
          this.ResetForm();
          this.$swal({ title: 'Item Was Saved!', icon: 'success' });
          this.$router.push({
            name: 'Admin.Projects.Index'
          });
        })
        .catch(err => {
          this.savingItem = false;
          if (err.response && err.response.data && err.response.data.errorMessage) {
            this.$swal({ title: err.response.data.errorMessage, icon: 'error' });
          } else {
            this.$swal({ title: 'Item Was NOT Saved!', icon: 'error' });
          }
        });
    }
  }
};
</script>
